import { POST } from "../../APiHelper/API"

export const getTeamsUsedInValidCupsAPI = (team_id, onSuccess, onError) => {
    const data = {
        team_id: team_id,

    }
    POST("/api/v1/seasons_and_cups/team_used_in_valid_cups", data, onSuccess, onError)
}